<template>
  <div
    class="page-container"
    :class="{
      'page-container__h5': isH5,
      'page-container__electron': isElectron,
    }"
  >
    <div class="header" v-if="!isH5 && !isElectron">
      课程评价
      <span class="header-back" @click="back"></span>
    </div>
    <div class="tabs-wrap">
      <div class="tabs-box">
        <tabs :tabsData="tabsData" @change="changeTabs"></tabs>
        <span class="header-back" @click="back" v-if="!isHXApp"></span>
      </div>
    </div>
    <div class="list-box">
      <div
        class="no-evaluate-list"
        v-if="
          activeTab.type === 'noEvaluate' &&
          noEvaluateList &&
          noEvaluateList.length
        "
      >
        <div
          class="no-evaluate-item"
          v-for="item in noEvaluateList"
          :key="item.id"
          @click="goToProductDetail(item)"
        >
          <template v-if="!isH5">
            <div class="cover-box">
              <img
                :src="cdnUrl + item.cover_url + '?imageView2/0/w/280'"
                alt=""
              />
            </div>
            <div class="evaluate-center">
              <div class="name">{{ item.course_name }}</div>
              <div class="count-box">
                <span class="count"
                  >已学{{ item.learned_lesson_count }}课时</span
                >
                <p class="white-btn" @click.stop="goToEvaluate(item)">去评价</p>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="evaluate-top">
              <div class="cover-box">
                <img
                  :src="cdnUrl + item.cover_url + '?imageView2/0/w/100'"
                  alt=""
                />
              </div>
              <div class="name">{{ item.course_name }}</div>
            </div>
            <div class="count-box">
              <span class="count">已学{{ item.learned_lesson_count }}课时</span>
              <p class="white-btn" @click.stop="goToEvaluate(item)">去评价</p>
            </div>
          </template>
        </div>
      </div>
      <div
        class="evaluated-list"
        v-else-if="
          activeTab.type === 'evaluted' && evaluatedList && evaluatedList.length
        "
      >
        <div
          class="evaluated-item"
          v-for="item in evaluatedList"
          :key="item.id"
          @click="goToEvaluateDetail(item)"
        >
          <template v-if="!isH5">
            <div class="cover-box">
              <img :src="item.cover_url + '?imageView2/0/w/280'" alt="" />
            </div>
            <div class="evaluate-center">
              <div class="name">{{ item.course_name }}</div>
              <div class="star">
                <span>整体评价</span>
                <star :score="item.star"></star>
              </div>
              <div class="time">
                {{
                  moment(item.last_update_time * 1000).format(
                    "YYYY-MM-DD HH:mm"
                  )
                }}
              </div>
            </div>
            <div class="evaluate-right">
              <div>{{ item.anonymity === 1 ? "匿名" : "" }}</div>
              <div>{{ item.like }} 人觉得有用</div>
            </div>
          </template>
          <template v-else>
            <div class="evaluate-top">
              <div class="cover-box">
                <img :src="item.cover_url" alt="" />
              </div>
              <div class="evaluate-center">
                <div class="name">{{ item.course_name }}</div>
                <div class="star">
                  <span>整体评价</span> <star :score="item.star"></star>
                </div>
                <div class="time">
                  {{
                    moment(item.last_update_time * 1000).format(
                      "YYYY-MM-DD HH:  mm"
                    )
                  }}
                </div>
              </div>
            </div>
            <div class="evaluate-right">
              <div>{{ item.anonymity === 1 ? "匿名" : "" }}</div>
              <div>{{ item.like }} 人觉得有用</div>
            </div>
          </template>
        </div>
      </div>
      <el-empty
        v-else
        class="empty-box"
        :description="
          activeTab.type === 'noEvaluate' ? '暂无待评价课程' : '暂无已评价课程'
        "
        :image="require('../../assets/images/comment/empty.png')"
      ></el-empty>
    </div>
  </div>
</template>

<script>
import {
  getEvaluatedList,
  getUnEvaluatedList,
} from "@saas/service-api/src/evaluate/index";
import { jsToFlutter } from "@saas/components/src/utils/js-to-flutter";
import { isH5, isHXApp } from "@saas/components/src";
import Tabs from "@saas/components/src/components/tabs/Index.vue";
import Star from "@saas/components/src/components/star/Star.vue";
import moment from "moment";
import { EventBus } from "@saas/components/src/utils/event-bus";
export default {
  name: "CommentList",
  components: {
    Tabs,
    Star,
  },
  data() {
    return {
      isH5: isH5(),
      isHXApp: isHXApp(),
      moment: moment,
      isElectron: window.isElectron,
      tabsData: [
        {
          title: "待评价",
          isActive: true,
          type: "noEvaluate",
        },
        {
          title: "已评价",
          isActive: false,
          type: "evaluted",
        },
      ],
      noEvaluateList: [],
      evaluatedList: [],
      cdnUrl: process.env.VUE_APP_CDN_URL,
      noEvaluatePageInfo: {
        loading: false,
        noMore: false,
        page: 1,
        pageSize: 50,
        total: 0,
        has_next: false,
      },
      evaluatedPageInfo: {
        loading: false,
        noMore: false,
        page: 1,
        pageSize: 50,
        total: 0,
        has_next: false,
      },
    };
  },
  computed: {
    activeTab() {
      return this.tabsData.find((item) => item.isActive);
    },
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        if (window.isElectron) {
          let elMain = document.getElementById("electron-main");
          if (!elMain) return;
          elMain.addEventListener("scroll", this.handleElScrollFn, true);
        } else {
          window.addEventListener("scroll", this.scrollFn, true); //监听页面滚动
        }
      }, 2000);
    });
  },
  activated() {
    if (this.isHXApp) {
      jsToFlutter("getToken");
      EventBus.$off("setToken");
      EventBus.$on("setToken", () => {
        // 获取页面信息
        this.initData();
      });
    } else {
      this.initData();
    }
  },
  methods: {
    testAction() {
      jsToFlutter("toMain", { index: 0 });
    },
    initData() {
      this.noEvaluateList = [];
      this.evaluatedList = [];
      this.noEvaluatePageInfo = {
        loading: false,
        noMore: false,
        page: 1,
        pageSize: 50,
        total: 0,
        has_next: false,
      };
      this.evaluatedPageInfo = {
        loading: false,
        noMore: false,
        page: 1,
        pageSize: 50,
        total: 0,
        has_next: false,
      };
      this.getEvaluatedListData();
      this.getNoEvaluateListData();
    },
    // 去商品详情页
    goToProductDetail(item) {
      this.$router.push("/product-detail/" + item.course_id);
    },
    // 去评价详情页
    goToEvaluateDetail(item) {
      this.$router.push("/comment-info/" + item.id);
    },
    // 获取已评价列表
    getEvaluatedListData() {
      this.evaluatedPageInfo.loading = true;
      getEvaluatedList({
        page_no: this.evaluatedPageInfo.page,
        page_size: this.evaluatedPageInfo.pageSize,
      })
        .then((res) => {
          if (res.code === 1) {
            const list = res.data.list || [];
            const total = res.data.total;
            this.evaluatedList = [...this.evaluatedList, ...list] || [];
            this.evaluatedPageInfo.noMore = this.evaluatedList.length >= total;
          }
        })
        .finally(() => {
          this.evaluatedPageInfo.loading = false;
        });
    },
    // 获取未评价列表
    getNoEvaluateListData() {
      this.noEvaluatePageInfo.loading = true;
      getUnEvaluatedList({
        page_no: this.noEvaluatePageInfo.page,
        page_size: this.noEvaluatePageInfo.pageSize,
      })
        .then((res) => {
          if (res.code === 1) {
            const list = res.data.list || [];
            const total = res.data.total;
            this.noEvaluateList = [...this.noEvaluateList, ...list] || [];
            this.noEvaluatePageInfo.noMore =
              this.noEvaluateList.length >= total;
          }
        })
        .finally(() => {
          this.noEvaluatePageInfo.loading = false;
        });
    },
    changeTabs() {},
    back() {
      window.history.go(-1);
    },
    // 去评价
    goToEvaluate(item) {
      getUnEvaluatedList({
        page_no: 1,
        page_size: 1,
        course_id: item.course_id,
      }).then((res) => {
        if (res.code === 1) {
          const courseInfo = res.data.list[0] || {};
          if (courseInfo.lesson_count < 1) {
            this.$message.error("课程中暂无课时，不能评价");
          } else if (courseInfo.learned_lesson_count < 1) {
            this.$message.error("至少学完一个课时才可以评价");
          } else {
            this.$router.push("comment/" + item.course_id);
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    /// 加载下一页
    loadMore() {
      if (this.activeTab.type === "noEvaluate") {
        this.noEvaluatePageInfo.page++;
        this.getNoEvaluateListData();
      } else {
        this.evaluatedPageInfo.page++;
        this.getEvaluatedListData();
      }
    },
    // 是否可以加载下一页
    canLoadMore() {
      if (this.activeTab.type === "noEvaluate") {
        if (this.noEvaluatePageInfo.loading || this.noEvaluatePageInfo.noMore) {
          return false;
        } else {
          return true;
        }
      } else {
        if (this.evaluatedPageInfo.loading || this.evaluatedPageInfo.noMore) {
          return false;
        } else {
          return true;
        }
      }
    },
    handleElScrollFn(event) {
      if (!this.canLoadMore()) {
        return false;
      }
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      // 触底-加载下一页
      if (scrollTop + clientHeight >= scrollHeight - 20) {
        this.loadMore();
      }
    },
    scrollFn() {
      if (!this.canLoadMore()) {
        return false;
      }
      //获取网页的总高度
      var htmlHeight =
        document.body.scrollHeight || document.documentElement.scrollHeight;
      //clientHeight是网页在浏览器中的可视高度
      var clientHeight =
        document.body.clientHeight || document.documentElement.clientHeight;
      //scrollTop是浏览器滚动条的top位置
      var scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      //判断到底部了
      if (scrollTop + clientHeight > htmlHeight - 100) {
        this.loadMore();
      }
    },
  },
  beforeDestroy() {
    if (window.isElectron) {
      let elMain = document.getElementById("electron-main");
      if (!elMain) return;
      elMain.removeEventListener("scroll", this.handleElScrollFn, true);
    } else {
      window.removeEventListener("scroll", this.scrollFn, true); //销毁滚动事件
    }
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  min-height: 100vh;
  overflow: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: 100px;
  padding-top: 136px;
  .header {
    width: 100%;
    height: 70px;
    line-height: 70px;
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    color: var(--text-primary, #{$saas-text-color});
    background: var(--card-bg, #ffffff);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
    .header-back {
      position: absolute;
      width: 9px;
      height: 13px;
      top: 50%;
      left: 50%;
      transform: translate(-400px, -50%);
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center center;
      background-image: url("../../assets/images/group-activity/back-icon.png");
      cursor: pointer;
    }
  }
  .tabs-wrap {
    overflow: hidden;
    width: 100%;
    height: 86px;
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    top: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--page-bg, #f7f8f9);
    .tabs-box ::v-deep {
      width: 800px;
      height: 46px;
      background: var(--card-bg, #ffffff);
      border-radius: 16px;
      padding-left: 40px;
      // margin-top: 20px;

      .tabs-container {
        height: 46px;
        justify-content: flex-start;
        align-items: center;
      }
      .tabs {
        font-weight: 400;
        height: 100%;
        align-items: center;
        .indicator {
          bottom: 0;
        }
        .tab {
          font-size: 16px;
          color: var(--text-secondary, #515350);
          &.active {
            color: var(--text-primary, rgba(13, 20, 0, 1));
          }
        }
      }
    }
  }

  .list-box {
    width: 800px;
    margin-top: 20px;
    // height: calc(100vh - 136px);
    // overflow: auto;
    .evaluated-list {
      .evaluated-item {
        padding: 14px 18px 14px 14px;
        height: 106px;
        background: var(--card-bg, #ffffff);
        border: 1px solid var(--border-subtle, transparent);
        border-radius: 20px;
        margin-bottom: 16px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        cursor: pointer;
        .cover-box {
          height: 78px;
          width: 140px;
          border-radius: 12px;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .evaluate-center {
          margin-left: 12px;
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .name {
            font-weight: 600;
            font-size: 18px;
            height: 25px;
            line-height: 25px;
            color: var(--text-primary, #0d1400);
            display: -webkit-box;
            -webkit-line-clamp: 1;
            /* 调整这里的数值以适应需要显示的行数 */
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .star {
            display: flex;
            flex-direction: row;
            align-items: center;
            span {
              font-weight: 500;
              font-size: 14px;
              color: var(--text-primary, #0d1400);
              line-height: 20px;
              margin-right: 8px;
            }
          }
          .time {
            font-size: 14px;
            color: var(--text-secondary, #515350);
            line-height: 20px;
            height: 20px;
          }
        }
        .evaluate-right {
          width: 140px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: flex-end;
          color: var(--text-secondary, #515350);
          font-size: 14px;
        }
      }
    }
    .no-evaluate-list {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      .no-evaluate-item {
        width: 390px;
        height: 106px;
        background: var(--card-bg, #ffffff);
        border: 1px solid var(--border-subtle, transparent);
        border-radius: 20px;
        padding: 14px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 16px;
        cursor: pointer;
        .cover-box {
          height: 78px;
          width: 140px;
          border-radius: 12px;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .evaluate-center {
          flex: 1;
          margin-left: 8px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .name {
            font-weight: 500;
            font-size: 18px;
            line-height: 25px;
            color: var(--text-primary, #0d1400);
            display: -webkit-box;
            -webkit-line-clamp: 2;
            /* 调整这里的数值以适应需要显示的行数 */
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
          }
          .count-box {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            .count {
              font-size: 14px;
              color: var(--text-secondary, #747573);
            }
            .white-btn {
              cursor: pointer;
              text-align: center;
              padding: 0 9px;
              height: 26px;
              line-height: 26px;
              background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
              border-radius: 13px;
              font-weight: 600;
              font-size: 14px;
              color: #ffffff;
            }
          }
        }
      }
    }
  }
  .empty-box ::v-deep {
    width: 800px;
    height: 450px;
    background: var(--card-bg, #ffffff);
    border-radius: 20px;
    .el-empty__image {
      width: 120px;
      height: 120px;
    }
    .el-empty__description {
      font-weight: 600;
      font-size: 18px;
      line-height: 25px;
      height: 25px;
      p {
        color: var(--text-primary, #0d1400);
      }
    }
  }
}
.page-container__h5 {
  min-height: 100vh;
  padding-bottom: 2.6667rem;
  padding-top: 1.2533rem;
  .tabs-wrap {
    overflow: hidden;
    width: 100%;
    height: 1.2rem;
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--page-bg, #f7f8f9);
    .tabs-box ::v-deep {
      width: 100%;
      height: 1.2rem;
      padding-left: 0;
      margin-top: 0;
      position: relative;
      background: none;
      .header-back {
        position: absolute;
        left: 0.4rem;
        top: 0.4267rem;
        width: 0.24rem;
        height: 0.3467rem;

        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center center;
        background-image: url("../../assets/images/group-activity/back-icon.png");
        cursor: pointer;
      }
      .tabs-container {
        width: 100%;
        height: 1.2rem;
      }
      .tabs {
        margin: 0 auto;
        font-weight: 400;
        height: 100%;
        align-items: center;
        .indicator {
          bottom: 0.16rem;
        }
        .tab {
          font-size: 0.4267rem;
        }
      }
    }
  }
  .list-box {
    width: 100%;
    padding: 0 0.32rem;
    margin-top: 0.0533rem;
    .evaluated-list {
      .evaluated-item {
        padding: 0.32rem 0.32rem 0.2667rem 0.32rem;
        height: 3.0667rem;
        background: var(--card-bg, #ffffff);
        border-radius: 0.32rem;
        margin-bottom: 0.2133rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .evaluate-top {
          display: flex;
          .cover-box {
            width: 2.8rem;
            height: 1.5333rem;
            border-radius: 0.1333rem;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          .evaluate-center {
            margin-left: 0.16rem;
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .name {
              font-weight: 600;
              font-size: 0.3733rem;
              height: 0.5333rem;
              line-height: 0.5333rem;
              color: var(--text-primary, #0d1400);
              display: -webkit-box;
              -webkit-line-clamp: 1;
              /* 调整这里的数值以适应需要显示的行数 */
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .star {
              display: flex;
              align-items: center;
              height: 0.64rem;
              line-height: 0.64rem;
              overflow: hidden;

              span {
                font-weight: 500;
                font-size: 0.32rem;
                color: var(--text-primary, #0d1400);
                line-height: 0.64rem;
              }
            }
            .time {
              font-size: 0.32rem;
              color: var(--text-secondary, #515350);
              line-height: 0.44rem;
              height: 0.44rem;
            }
          }
        }
        .evaluate-right {
          padding-top: 0.16rem;
          height: 0.44rem;
          border-top: 1px solid var(--border-subtle, #efefef);
          width: 100%;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          color: var(--text-secondary, #515350);
          font-size: 0.32rem;
        }
      }
    }
    .no-evaluate-list {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      .no-evaluate-item {
        width: 100%;
        height: 3.4667rem;
        background: var(--card-bg, #ffffff);
        border: 1px solid var(--border-subtle, transparent);
        border-radius: 0.32rem;
        padding: 0.32rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-bottom: 0.2133rem;
        .evaluate-top {
          display: flex;
          align-items: center;
          border-bottom: 1px solid var(--border-subtle, #efefef);
          padding-bottom: 0.32rem;
          .cover-box {
            width: 2.8rem;
            height: 1.5333rem;
            border-radius: 0.1333rem;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          .name {
            margin-left: 0.16rem;
            flex: 1;
            font-weight: 500;
            font-size: 0.3733rem;
            line-height: 0.5333rem;
            color: var(--text-primary, #0d1400);
            display: -webkit-box;
            -webkit-line-clamp: 2;
            /* 调整这里的数值以适应需要显示的行数 */
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
          }
        }
        .count-box {
          margin-top: 0.2667rem;
          height: 0.72rem;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          .count {
            font-size: 0.32rem;
            color: var(--text-secondary, #747573);
          }
          .white-btn {
            width: 1.88rem;
            height: 0.72rem;
            line-height: 0.72rem;
            cursor: pointer;
            text-align: center;
            color: #fff;
            background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
            border-radius: 0.16rem;
            font-weight: 600;
            font-size: 0.3733rem;
          }
        }
      }
    }
  }
  .empty-box ::v-deep {
    width: 100%;
    background: none;
    border-radius: 0;
    .el-empty__image {
      width: 3.2rem;
      height: 3.2rem;
    }
    .el-empty__description {
      font-weight: 600;
      font-size: 0.4rem;
      line-height: 0.56rem;
      height: 0.56rem;
      p {
        color: var(--text-primary, #0d1400);
      }
    }
  }
}
.page-container__electron {
  // .header {
  //   width: calc(100% - 64px);
  //   top: 50px;
  //   right: 0;
  //   left: auto;
  // }
  padding-top: 70px;
  .tabs-wrap {
    width: calc(100% - #{$side-bar-width});
    top: $nav-height;
    right: 0;
    left: auto;
    transform: translate(0, 0);
  }
}
</style>
